import { render, staticRenderFns } from "./UserProtectedData.vue?vue&type=template&id=f5ce940c&scoped=true"
import script from "./UserProtectedData.vue?vue&type=script&lang=js"
export * from "./UserProtectedData.vue?vue&type=script&lang=js"
import style0 from "./UserProtectedData.vue?vue&type=style&index=0&id=f5ce940c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ce940c",
  null
  
)

export default component.exports